import {Directive, ElementRef, Input} from '@angular/core';

@Directive({
  selector: '[appImagePreview]'
})
export class ImagePreviewDirective {

  @Input() image: any;

  constructor(private el: ElementRef) {
  }

  ngOnChanges() {
    const reader = new FileReader();
    const el = this.el;

    reader.onloadend = function () {
      el.nativeElement.src = reader.result;
    };

    if (this.image) {
      return reader.readAsDataURL(this.image);
    }
  }
}
